/**
 * @function isValidEnum
 * @param {string | number} key param to check if valid enum entry
 * @param {any[]} enums enum or list of enums
 * @description Checks a value if a valid enum entry
 * @returns {boolean}
 */
const isValidEnum = (key: string | number, ...enums: any[]): boolean => {
  let isMatched = false;
  enums.every((enumType) => {
    if ((enumType as any)[key]) {
      isMatched = true;
      return false;
    }
    return true;
  });

  return isMatched;
};

export default isValidEnum;
